import React from "react";

/**
 * Function to render a downloaded filled icon as an SVG.
 *
 * @param {object} cls - the class name for styling the SVG
 * @return {JSX.Element} the SVG element for the downloaded filled icon
 */
export const DownloadFilledIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cls}
    >
      <path
        d="M20.413 21.1835H3.58708C3.16643 21.1835 2.82227 20.8394 2.82227 20.4187C2.82227 19.9981 3.16643 19.6539 3.58708 19.6539H20.413C20.8337 19.6539 21.1778 19.9981 21.1778 20.4187C21.1778 20.8394 20.8337 21.1835 20.413 21.1835ZM14.1186 17.2524L18.9752 12.0899C19.6406 11.4245 19.8318 10.4761 19.4723 9.61187C19.1128 8.74763 18.3098 8.20461 17.3691 8.19696H15.8241V5.11476C15.8318 3.83752 14.784 2.82031 13.5144 2.82031H10.4704C9.20082 2.82031 8.17597 3.84517 8.17597 5.11476V8.17402H6.74577C5.85093 8.17402 4.98669 8.64056 4.59664 9.44361C4.16069 10.3461 4.3366 11.3633 5.00964 12.044L9.82032 17.2447C10.4092 17.8336 11.1893 18.1319 11.9695 18.1319C12.7496 18.1319 13.522 17.8336 14.1186 17.2447V17.2524Z"
        fill="currentColor"
      />
    </svg>
  );
};
